import { useState } from 'react';
import { ErrorMessage, Field, Form, Formik } from "formik";
import { Button, CircularProgress, TextField } from "@mui/material";
import * as Yup from "yup";
import './index.scss';
import { MessageText } from '../../constants/messageText';
import instance from '../../utils/axiosInstance';
import { UpdateTrialDaysRequest } from '../../constants/api-urlConstants';
import { apiBasePathUserDetail } from '../../constants/env-url';
import { SnackBarMessage } from '../snackBar/snackBar';

const UpdateTrialDaysFormValidation = Yup.object().shape({
  trialDays: Yup
    .number()
    .integer()
    .moreThan(1, MessageText.TRIALDAYS_PERIOD)
    .lessThan(101, MessageText.TRIALDAYS_PERIOD)
    .required(MessageText.VALIDATION_TRIALDAYS_REQUIRED)
});

export const UpdateTrialDays = (props: any) => {
  const { selectedUser, onCancel, onSaveAndClose } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [APIMsgCongig, setAPIMsgCongig] = useState({
    type: '',
    message: '',
    snackFlag: false
  });
  const initial_state = {
    trialDays: selectedUser.trialDays || 0,
  }

  const setAlertMessage = (type: string, message: string, flag: boolean) => {
    setAPIMsgCongig({
      type: type,
      message: message,
      snackFlag: flag
    });
  }

  const onSubmit = (value: any) => {
    setIsLoading(true);
    const USER_API_BASE_URL = `${apiBasePathUserDetail}${UpdateTrialDaysRequest}`;
    const userData = {
      userId: selectedUser.id,
      trialDays: value.trialDays
    };
    instance
      .post(USER_API_BASE_URL, userData)
      .then((response: any) => {
        if (response?.data?.success) {
          setAlertMessage('success', MessageText.TRIAL_DAYS_SUCCESS, true);
        }
        setTimeout(() => {
          onSaveAndClose();
        }, 1000);
      })
      .catch(() => {
        setAlertMessage('error', MessageText.TRIAL_DAYS_FAILED, true);
      })
      .finally(() => {
        setIsLoading(false);
        props?.closeConfirmation?.(true);
      });
  }

  return (
    <div className="popupActions">
      <Formik
        enableReinitialize={true}
        initialValues={initial_state}
        onSubmit={onSubmit}
        validationSchema={UpdateTrialDaysFormValidation}
      >
        {({ touched, errors, handleChange, handleSubmit, values }) => (
          <div className="update-trial-days-form">
            <Form onSubmit={handleSubmit}>
              <Field
                type="number"
                as={TextField}
                margin="normal"
                error={touched.trialDays && Boolean(errors.trialDays)}
                fullWidth
                min={2}
                max={100}
                label="Trial Days*"
                name="trialDays"
                autoComplete="trialDays"
                size="small"
                value={values.trialDays === 0 ? "" : values.trialDays}
                InputLabelProps={{ shrink: true }}
                onChange={(event: any) => handleChange(event)}
                inputProps={{
                  autoComplete: "new-trialDays",
                  form: {
                    autoComplete: "off",
                  },
                }}
                helperText={<ErrorMessage name="trialDays" />}
              />
              <div className='flex justify-between action'>
                <Button
                  className={props?.buttonName === 'Approve' ? "secondaryBtnGreen" : "secondaryBtn"}
                  onClick={onCancel}
                  style={{ textTransform: "none" }}
                  type='button'
                >
                  Cancel
                </Button>
                {isLoading && <div className="loader">
                  <div>
                    <CircularProgress size={25} />
                  </div>
                </div>
                }
                {!isLoading &&
                  <Button
                    autoFocus
                    className={props?.buttonName === 'Approve' ? "primeryBtnGreen" : "primeryBtn"}
                    style={{ textTransform: "none", }}
                    type='submit'
                  >
                    {props?.buttonName ? props?.buttonName : "save"}
                  </Button>
                }
              </div>
            </Form>
          </div>
        )}
      </Formik>
      {APIMsgCongig.snackFlag &&
        <div>
          <SnackBarMessage snacBarValue={APIMsgCongig} />
        </div>
      }
    </div>
  );
}